import type L from "leaflet";
import { generateGoogleMapUrl } from "./index";

interface LatLng {
  lat: number;
  lng: number;
}

/**
 * Google Maps（衛星写真）のURLを、いまの地図のズームで生成する
 * 別のページへ移るものなので、ボタンでなくリンクの href に使う
 * @param map Leafletのマップオブジェクト
 * @param latlng 緯度経度（nullの場合はundefinedを返す）
 * @returns Google MapsのURL、またはundefined
 */
export const getGoogleMapsUrl = (
  map: L.Map,
  latlng: LatLng | null | undefined
): string | undefined => {
  if (!latlng) return undefined;
  return generateGoogleMapUrl(map.getZoom(), latlng);
};
